import useDataFetching from "hooks/useDataFetching";
import { formatDate } from "utils";
import { config } from "variables/config";
import MuiTable from "components/MuiTable";
import MButton from "components/Mbutton";
import { useNavigate } from "react-router-dom";
import { useDisclosure } from "@chakra-ui/hooks";
import { useState } from "react";
import { BsArrowRepeat, BsList, BsPlusCircle, BsCheck2Circle } from "react-icons/bs";
import AddTaskEnterprise from "./AddTaskEnterprise";
import AddTask from "./AddTask";
import { getFullName } from "utils";
import { Tooltip } from "@chakra-ui/tooltip";
import { Chip, IconButton, capitalize } from "@mui/material";
import { TASK_HEADER } from "Constaints";
import axios from "axios";
import toast from "react-hot-toast";
import { formatNumber } from "utils";
import { Badge } from "@chakra-ui/react";
import { useAuthHeader } from "react-auth-kit";
import { useTranslation } from "react-i18next";

export default function Tasks() {
    const navigate = useNavigate();
    const authHeader = useAuthHeader();
    const { t } = useTranslation("tasks_list");

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [open, setOpen] = useState(false);

    const [loading, errorE, tasks, fetchtaks] = useDataFetching(
        `${config.app.api_url}/tasks`
    );

    const [selectedTask, setselectedTask] = useState(null);

    const handleChangeStatus = ({ taskId, completed }) => {
        toast.promise(axios.put(`${config.app.api_url}/tasks/${taskId}/change-status?completed=${completed}`, {}, { headers: { Authorization: authHeader() } }), {
            loading: 'Loading',
            success: () => {
                fetchtaks();
                return completed ? t('task_completed_success') : t('task_incomplete_success'); // Traduit
            },
            error: t('error_occurred'), // Traduit
        });
    };

    const handleClick = (item) => {
        onOpen();
        setselectedTask(item);
    };

    function createData(N, description, start, end, region, department, arrondissement, zone, status, actions) {
        return {
            N, description, start, end, region, department, arrondissement, zone, status, actions
        };
    }

    const rows = tasks?.data?.sort((a, b) => new Date(b?.start) > new Date(a?.start) ? -1 : 1)?.map((item, index) => {
        return {
            handleClick: () => handleClick(item),
            datas: createData(
                index + 1,
                item?.description,
                formatDate(item.start),
                formatDate(item?.end),
                item?.region?.name,
                item?.department?.name,
                item?.arrondissement?.name,
                item?.zone?.description,
                (new Date(item?.end) < new Date() && !item?.completed) ?
                    <Chip color='error' className="capitalize-none" label={capitalize(t("status_late"))} /> : // Traduit
                    item?.completed ?
                        <Chip color='success' className="capitalize-none" label={capitalize(t("status_completed"))} /> : // Traduit
                        <Chip className="capitalize-none" variant="outlined" color='info' label={t("status_in_progress")} />, // Traduit
                <div className="flex flex gap-0">
                    <Tooltip hasArrow label={t("enterprise_list")} bg='green.200' color='black' placement="bottom">
                        <div>
                            <IconButton
                                color='primary'
                                onClick={(e) => { e?.stopPropagation(); navigate("/admin/enterprises", { state: { task: item } }); }}
                            >
                                <BsList />
                            </IconButton>
                        </div>
                    </Tooltip>

                    <Tooltip hasArrow label={t("assign_enterprise")} bg='green.200' color='black' placement="bottom">
                        <div>
                            <IconButton
                                color="success"
                                onClick={(e) => { e?.stopPropagation(); setselectedTask(item); setOpen(true); }}
                            >
                                <BsPlusCircle />
                            </IconButton>
                        </div>
                    </Tooltip>

                    {!item?.completed ? (
                        <Tooltip hasArrow label={t("mark_as_completed")} bg='green.200' color='black' placement="bottom">
                            <div>
                                <IconButton
                                    color="success"
                                    onClick={(e) => { e?.stopPropagation(); handleChangeStatus({ taskId: item?.id, completed: true }); }}
                                >
                                    <BsCheck2Circle />
                                </IconButton>
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip hasArrow label={t("mark_as_incomplete")} bg='green.200' color='black' placement="bottom">
                            <div>
                                <IconButton
                                    color="warning"
                                    onClick={(e) => { e?.stopPropagation(); handleChangeStatus({ taskId: item?.id, completed: false }); }}
                                >
                                    <BsArrowRepeat />
                                </IconButton>
                            </div>
                        </Tooltip>
                    )}
                </div>
            ),
            history: item?.participants ? {
                title: t("participants_list"), // Traduit
                header: [
                    "#",
                    t("full_name"), // Traduit
                ],
                datas: item?.participants?.map((p, index) => {
                    return {
                        index: index + 1,
                        salary: getFullName(p),
                    };
                })
            }
                : []
        };
    });

    return (
        <>
            <div className="flex justify-end my-2 shadow-lg bg-white rounded-lg border py-2">
                <div className="flex flex-1 justify-center mt-2">
                    <strong>
                        {t("total")}
                        <Badge
                            fontSize={13}
                            rounded={5}
                            padding={1}
                            paddingInline={2}
                            colorScheme="orange"
                            className="mx-1"
                        >
                            {formatNumber(tasks?.data?.length) || '--'}
                        </Badge>
                    </strong>
                    <>
                        <strong>
                            {t("completed")}
                            <Badge
                                fontSize={13}
                                rounded={5}
                                padding={1}
                                paddingInline={2}
                                colorScheme="green"
                                className="mx-1"
                            >
                                {formatNumber(tasks?.data?.filter((e) => e?.completed)?.length) || '--'}
                            </Badge>
                        </strong>

                        <strong>
                            {t("in_progress")}
                            <Badge
                                fontSize={13}
                                rounded={5}
                                padding={1}
                                paddingInline={2}
                                colorScheme="blue"
                                className="mx-1"
                            >
                                {formatNumber(tasks?.data?.filter((e) => !e?.completed)?.length) || '--'}
                            </Badge>
                        </strong>
                        <strong>
                            {t("late")}
                            <Badge
                                fontSize={13}
                                rounded={5}
                                padding={1}
                                paddingInline={2}
                                colorScheme="red"
                                className="mx-1"
                            >
                                {formatNumber(tasks?.data?.filter((e) => new Date(e?.end) < new Date())?.length) || '--'}
                            </Badge>
                        </strong>
                    </>
                </div>
                <MButton variant={"primary"} onClick={() => { onOpen(); }} >
                    <BsPlusCircle /> {t("create_task")}
                </MButton>
            </div>
            <MuiTable
                loading={loading}
                hidePagiation={true}
                columns={TASK_HEADER(t)}
                rows={rows}
                textEmpty={t("no_tasks")} />
            <AddTask selectedTask={selectedTask} endFetch={fetchtaks} isOpen={isOpen} onClose={() => { setselectedTask(null); onClose(); }} />
            <AddTaskEnterprise endFetch={fetchtaks} task={selectedTask} isOpen={open} onClose={() => { setselectedTask(null); setOpen(false); }} />
        </>
    );
}